/**
 * Variant sync, quantity controls, and video placeholder toggles for the campaign protein drinks section.
 * Depends on jQuery (loaded from theme.liquid for this template suffix).
 */
(function () {
  function initCampaignProteinDrinks() {
    if (typeof window.jQuery === 'undefined') {
      return;
    }
    var $ = window.jQuery;

    setTimeout(function () {
      if (typeof window.AOS !== 'undefined' && typeof window.AOS.init === 'function') {
        window.AOS.init({ offset: -200 });
      }
    }, 200);

    var root = $('html,body');

    $('.my-product-form').off('change.cpd').on('change.cpd', function () {
      var els = $(this).parent().parent().find('select.product-form__variants option');
      for (var i = 0; i < els.length; i++) {
        if ($.trim($(els.get(i)).text()) === $.trim($(this).val())) {
          $($(this).parent().parent().find('select.product-form__variants')).val($(els.get(i)).val());
          $($(this).parent().parent().find('.bold-ro__one-time-price')).text($(els.get(i)).data('price'));
          $($(this).parent().parent().find('.price-number')).text($(els.get(i)).data('price'));
        }
      }
    });

    $('.qty-btn.left')
      .off('click.cpd')
      .on('click.cpd', function () {
        var elInput = $($(this).parent().find('input'));
        if (parseInt(elInput.val(), 10) >= 2) {
          elInput.val(parseInt(elInput.val(), 10) - 1);
        }
      });

    $('.qty-btn.right')
      .off('click.cpd')
      .on('click.cpd', function () {
        var elInput = $($(this).parent().find('input'));
        elInput.val(parseInt(elInput.val(), 10) + 1);
      });

    var v1 = $('.video-1 video').get(0);
    if (v1 && typeof v1.addEventListener === 'function') {
      v1.onended = function () {
        $('.video-image-1').removeClass('hidden');
        $('.video-1 video').addClass('hidden');
      };
    }

    var v2 = $('.video-2 video').get(0);
    if (v2 && typeof v2.addEventListener === 'function') {
      v2.onended = function () {
        $('.video-image-2').removeClass('hidden');
        $('.video-2 video').addClass('hidden');
      };
    }

    $('.video-image-1')
      .off('click.cpd')
      .on('click.cpd', function () {
        var el = $('.video-1 video').get(0);
        if (!el) return;
        $('.video-image-1').addClass('hidden');
        $('.video-1 video').removeClass('hidden');
        el.play();
      });

    $('.video-image-2')
      .off('click.cpd')
      .on('click.cpd', function () {
        var el = $('.video-2 video').get(0);
        if (!el) return;
        $('.video-image-2').addClass('hidden');
        $('.video-2 video').removeClass('hidden');
        el.play();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCampaignProteinDrinks);
  } else {
    initCampaignProteinDrinks();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.detail && ev.detail.sectionId) {
      initCampaignProteinDrinks();
    }
  });
})();
